export const appsettings = {
  //---DESARROLLO
  //apiUrl: "http://10.0.0.99:1234"
  //apiUrl: "http://127.0.0.1:1234"
  //apiUrl: "http://10.0.0.168:1234"

  //apiUrl: "http://150.189.200.12:1234"
  //---PRODUCCION
  //apiUrl: "https://pna.inces.gob.ve:1234"
  apiUrl: "https://pna.inces.gob.ve/pna"
}
